import { Component, OnInit, NgZone } from '@angular/core';
import * as firebase from 'firebase';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AmbitService } from '../ambit.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public submitted: boolean = false;
  public loading = false ;

  constructor(private formBuilder: FormBuilder,
    public router: Router,
    public service: AmbitService,
    public zone: NgZone,
    public toaster: ToastrService,
    public route: ActivatedRoute) {

      if(localStorage.getItem('AmbitUser')) {
        this.router.navigate(['/home']);
      }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
     
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'),
      ])],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  get f() { return this.loginForm.controls; }

  login() {
    var self = this;
    self.submitted = true;
    if (this.loginForm.valid) {
      self.loading = true;
      firebase.auth().signInWithEmailAndPassword(this.loginForm.get("email").value, this.loginForm.get("password").value)
      .then((user) => {
      
        if (user) {
          firebase.database().ref().child('Users/' + user.user.uid).once('value', (snapshot) => {
            self.zone.run(() => {
              var userData = snapshot.val();
              if (userData && userData.isAdmin) {

                self.service.adminUser = userData ;
                 localStorage.setItem('AmbitUser', JSON.stringify(userData)) ;
                 self.service.fetchAmbitRecord();
                 this.router.navigate(['/home']);
              } else {
                self.loading = false;
                self.toaster.error('Entered Credentials are not belonged to Super Admin, Kindly try again with valid credentials.', '', {timeOut:4000});
               }
            });
          }).catch( (error)=>{
            self.loading = false;
            self.toaster.error( error.message, '', {timeOut:4000});
          })

        }
      }).catch( (error)=>{
        self.loading = false;
        self.toaster.error( error.message, '', {timeOut:4000});
      })

      self.submitted = false;
     
    }
  }

}
